<ng-container *ngIf="!error">
<label class="form-label text-nowrap mb-0">Towing</label>
<div class="input-group">
  <span class="input-group-text">$</span>
  <input class="form-control" type="number" [disabled]="isLocked" [(ngModel)]="towing" (keyup)="updateTowing()">
</div>
</ng-container>
<ng-container *ngIf="error">An error occurred while updating towing.</ng-container>
